import Button from 'components/Button';
import FormActionGroup from 'components/FormActionGroup';
import Modal from 'components/Modal';
import Typography from 'components/Typography';
import {useHistory} from 'react-router-dom';
import CreatableSelect from 'components/CreatableSelect';
import styles from './SMSBlastModal.module.scss';
import {useSMSModal} from './useSMSModal';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  count?: number;
  customerIds: string[];
  metaDatas: any;
};

function SMSBlastModal({
  isOpen,
  onClose,
  count,
  customerIds,
  metaDatas,
}: Props) {
  const history = useHistory();

  const {
    templateOptions,
    selectedTemplate,
    setSelectedTemplate,
    message,
    setMessage,
    sendMessage,
    handleClose,
  } = useSMSModal({customerIds, metaDatas, onClose});
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      onRequestClose={onClose}
      className={styles.filterModal}
    >
      <Typography variant="h2">
        Send message to {count} {count === 1 ? 'person' : 'people'}
      </Typography>
      <textarea
        className={styles.messageTextarea}
        placeholder="Message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
      <div className={styles.label}>
        <div>Template</div>
      </div>
      <CreatableSelect
        components={{
          DropdownIndicator: () => null,
        }}
        onCreateOption={(inputValue: string) => {
          history.push('/settings/templates/create', {
            sharedDefaultValue: inputValue,
          });
        }}
        className={styles.templateSelect}
        placeholder="Search For Template"
        options={templateOptions}
        value={selectedTemplate}
        onChange={(option) => {
          setSelectedTemplate(option!);
          setMessage(option?.value as string);
        }}
      />
      <FormActionGroup className={styles.buttonWrap}>
        <Button onClick={sendMessage} color="blue">
          Send
        </Button>
      </FormActionGroup>
    </Modal>
  );
}

export default SMSBlastModal;
